const BehaviouralAnalysis = ({ behaviouralAnalysis }) => {
  const patterns = behaviouralAnalysis?.patterns;
  const shouldRender =
    behaviouralAnalysis?.status === "completed" &&
    Array.isArray(patterns) &&
    patterns.length > 0;

  if (!shouldRender) return null;

  return (
    <section className="behavioural-analysis">
      <div className="behavioural-analysis--header">
        <h4>Behavioural Analysis</h4>
        <p>
          Cross-question patterns observed across the candidate&apos;s responses.
        </p>
      </div>
      <div className="behavioural-analysis--patterns">
        {patterns.map(({ pattern, description }, index) => (
          <article
            className="behavioural-analysis--pattern"
            key={`${pattern}-${index}`}
          >
            <h5>{pattern}</h5>
            <p>{description}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default BehaviouralAnalysis;
